import React from 'react';
import { useHistory } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

import { Container } from './styles';

function Header({ children, count, back, profile, local, history }) {
  const { goBack } = useHistory();

  const justifycontent = back || !children ? 'flex-start' : '';
  const styledProps = {profile, back, justifycontent}

  if (true) return (
    <Container {...styledProps}>
      {children ? children : (
          <>
            <div>
              <button
                  onClick={goBack}
                type="button"
                style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
              >
                <FiArrowLeft size={'1.5rem'} color="#FFF" />
              </button>
            </div>

             <span>{count} {local}</span>

             <div />
          </>
        )}
    </Container>
  );
}

export default Header;
